module.exports = __webpack_public_path__ + "static/media/icon_195.a5cc2820.svg";